import { atom } from "recoil"

export const scheduleAnswerCsvDataRequestIdState = atom<number>({
  key: "atoms/csvData/scheduleAnswerCsvDataRequestIdState",
  default: 0,
})
